<template>
    <div class="task-manage-container">
        <star-condition-layout
                :onSearch="handleSearch"
                :onReset="reset"
                :loading="loading"
                ref="condition"
        >
            <star-condition-cell label="域名">
                <a-input v-model="search.domain"></a-input>
            </star-condition-cell>
            <star-condition-cell label="采集状态">
                <a-select allowClear style="width: 100%" v-model="search.status">
                    <a-select-option :value="0">等待采集</a-select-option>
                    <a-select-option :value="1">采集成功</a-select-option>
                    <a-select-option :value="2">采集失败</a-select-option>
                </a-select>
            </star-condition-cell>
            <star-condition-cell label="网站状态">
                <a-select allowClear style="width: 100%" v-model="search.audit">
                    <a-select-option :value="0">待审核</a-select-option>
                    <a-select-option :value="1">已生成站点</a-select-option>
                    <a-select-option :value="2">审核不通过</a-select-option>
                </a-select>
            </star-condition-cell>
            <star-condition-cell label="默认分类">
                <a-select allowClear style="width: 100%" v-model="search.label">
                    <a-select-option value="technology">科技</a-select-option>
                    <a-select-option value="military">军事</a-select-option>
                    <a-select-option value="politics">政治</a-select-option>
                    <a-select-option value="unknown">未知</a-select-option>
                </a-select>
            </star-condition-cell>
            <star-condition-cell label="二次分类">
                <a-select allowClear style="width: 100%" v-model="search.secondLabel">
                    <a-select-option value="technology" v-for="item in labelList" :value="item.newSitTagId" :key="item.newSitTagId" >{{item.newSitTagName}}</a-select-option>
                </a-select>
            </star-condition-cell>
        </star-condition-layout>
        <div class="table-container">

            <TableHeadIcons :onRefresh="getList" :size.sync="tableDensity" :columns="columns"/>

            <a-table
                    :size="tableDensity"
                    :loading="loading"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    @change="handleTableChange"
                    :columns="showColumns"
                    :data-source="tableData"
            >
                <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
                <span slot="domain" slot-scope="text, record">
                  <a :href="`http://${record.domain}`" target="_blank">{{ record.domain }}</a>
                </span>
                <span slot="url" slot-scope="text, record">
                  <a :href="record.url" target="_blank">{{record.url}}</a>
                </span>
                <span slot="statusName" slot-scope="text, record">
                    <span class="dot" v-if="record.status === 0"></span>
                    <span class="dot red" v-if="record.status === 2"></span>
                    <span class="dot green" v-if="record.status === 1"></span>
                  {{record.statusName}}
                </span>
                <span slot="auditName" slot-scope="text, record">
                     <span class="dot" v-if="record.audit === 0"></span>
                    <span class="dot red" v-if="record.audit === 2"></span>
                    <span class="dot green" v-if="record.audit === 1"></span>
                   {{record.auditName}}
                </span>
                <span slot="remark" slot-scope="text, record">
                     <a-tooltip v-if="record.remark" placement="top">
                        <template slot="title">
                          <span>{{record.remark}}</span>
                        </template>
                           {{record.remark }}
                     </a-tooltip>
                    <span v-else>-----</span>
                </span>
                <span slot="secondLabelName" slot-scope="text, record">
                     <a-tooltip v-if="record.secondLabelName" placement="top">
                        <template slot="title">
                          <span>{{record.secondLabelName}}</span>
                        </template>
                           {{record.secondLabelName }}
                     </a-tooltip>
                    <span v-else>-----</span>
                </span>
                <span slot="labelName" slot-scope="text, record">
                     <a-tooltip v-if="record.labelName" placement="top">
                        <template slot="title">
                          <span>{{record.labelName}}</span>
                        </template>
                           {{record.labelName }}
                     </a-tooltip>
                    <span v-else>-----</span>
                </span>

                <span slot="action" slot-scope="text, record">
                    <a-button v-if="record.audit === 2" :disabled="record.audit === 1" @click="editItem(record)"  type="link">审核编辑</a-button>
                    <a-button v-else @click="unpassItem(record)" :disabled="record.audit === 1" type="link">审核不通过</a-button>
                    <a-divider type="vertical"></a-divider>
                    <a-button @click="junpToCreate(record)" type="link" :disabled="record.audit === 1">生成站点</a-button>
                </span>
            </a-table>
        </div>

        <a-modal v-model="passFlag" title="站点审核" @cancle="closePass" @ok="submit" :afterClose="closePass">
            <p style="color: #333">审核不通过原因：</p>
            <a-checkbox-group v-model="remark">
                <div v-for="item in reasonList" style="margin-bottom: 8px">
                    <a-checkbox :value="item">{{item}}</a-checkbox>
                </div>
            </a-checkbox-group>

            <p v-if="showOtherLabel" style="color: #333;margin-top: 20px">重选分类</p>
            <ul v-if="showOtherLabel">
                <li
                        v-for="item in labelList"
                        :key="item.newSitTagId"
                        :class="labelIds.includes(item.newSitTagId) ? 'checked' : ''"
                        @click="checkedChange(item)"
                >{{item.newSitTagName}}
                </li>
            </ul>
        </a-modal>
    </div>
</template>

<script>
  import { getSideFindList, filterSpiderFindById, getLabelList } from '@/api/Site/find'
  import TableHeadIcons from '@/components/TableHeadIcons'
  import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

  export default {
    components: { TableHeadIcons },
    mixins: [tableSettingToStoreMixin()],
    data() {
      return {
        search: {
          domain: undefined,
          label: undefined,
          status: undefined,
          secondLabel: undefined,
          audit: undefined
        },
        tableDensity: 'middle',
        pagination: {
          current: 1,
          pageSize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          size: 'default'
        },
        tableData: [],
        columns: [
          {
            width: 60,
            title: '序号',
            align: 'center',
            show: true,
            slots: { title: 'indexTitle' },
            scopedSlots: { customRender: 'index' }
          },
          {
            title: '域名',
            dataIndex: 'domain',
            scopedSlots: { customRender: 'domain' },
            align: 'center',
            ellipsis: true,
            show: true
          },
          {
            title: '发现地址',
            scopedSlots: { customRender: 'url' },
            ellipsis: true,
            width: 200,
            align: 'center',
            show: true
          },
          {
            title: '采集状态',
            width: 130,
            scopedSlots: { customRender: 'statusName' },
            align: 'center',
            show: true
          },
          {
            title: '默认分类',
            width: 100,
            scopedSlots: { customRender: 'labelName' },
            align: 'center',
            ellipsis: true,
            show: true
          },
          {
            title: '网站状态',
            width: 130,
            scopedSlots: { customRender: 'auditName' },
            align: 'center',
            show: true
          },
          {
            title: '不通过原因',
            ellipsis: true,
            align: 'center',
            show: true,
            scopedSlots: { customRender: 'remark' }
          },
          {
            title: '二次分类',
            scopedSlots: { customRender: 'secondLabelName' },
            align: 'center',
            ellipsis: true,
            show: true
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            align: 'center',
            width: 180,
            show: true
          },
          {
            title: '审核人员',
            dataIndex: 'auditorName',
            align: 'center',
            width: 180,
            show: true
          },
          {
            title: '操作',
            show: true,
            scopedSlots: { customRender: 'action' },
            width: 200,
            align: 'center'
          }
        ],
        loading: false,
        passFlag: false,
        remark: [],
        singleDetail: {},

        reasonList: [
          '网站长时间不更新',
          '网站采集失效',
          '网站已被创建为站点',
          '网站内容与分类不符合'
        ],
        labelList: [],
        labelIds: []
      }
    },
    computed: {
      showColumns() {
        return this.columns.filter((item) => item.show)
      },
      showOtherLabel() {
        return this.remark.includes('网站内容与分类不符合')
      }
    },

    created() {
      this.getList()
      this.getLabelList()
    },
    methods: {
      checkedChange(item) {
        if (this.labelIds.includes(item.newSitTagId)) {
          let num = this.labelIds.indexOf(item.newSitTagId)
          this.labelIds.splice(num, 1)
        } else {
          this.labelIds.push(item.newSitTagId)
        }
      },
      async getList() {
        this.loading = true
        let { code, data, extra } = await getSideFindList({
          ...this.search,
          pn: this.pagination.current,
          pageSize: this.pagination.pageSize
        })
        this.loading = false
        if (code === 200) {
          this.tableData = data
          this.pagination.total = extra.page.pageCount || 0
        }
      },
      handleTableChange(pagination) {
        this.pagination = pagination
        this.getList()
      },

      handleSearch() {
        this.pagination.current = 1
        this.getList()
      },

      reset() {
        this.search.domain = undefined
        this.search.label = undefined
        this.search.status = undefined
        this.search.audit = undefined
        this.search.secondLabel = undefined
        this.handleSearch()
      },
      getLabelList() {
        getLabelList().then(res => {
          if (res.code === 200) {
            this.labelList = res.data
          }
        })
      },

      unpassItem(item) {
        this.getLabelList()
        this.singleDetail = item
        this.passFlag = true
      },
      closePass() {
        this.passFlag = false
        this.remark = []
        this.labelIds = []
      },
      editItem(row) {
        if(row.remark){
          this.remark = row.remark.split(',')
        }
        if( row.secondLabel){
          this.labelIds = row.secondLabel.split(',').map(item => {
            return parseInt(item)
          })
        }
        this.singleDetail = row
        this.passFlag = true
      },
      submit() {
        if (this.remark.length === 0) {
          this.$message.error('请选择不通过原因')
          return
        }
        if (this.remark.includes('网站内容与分类不符合') && this.labelIds.length === 0) {
          this.$message.error('请选择重选分类')
          return
        }
        filterSpiderFindById(
          {
            id: this.singleDetail.id,
            remark: this.remark.join(','),
            secondLabel: this.labelIds.join(',')
          }).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.closePass()
            this.getList()
          } else {
            this.$message.info(res.msg)
          }
        })
      },
      junpToCreate(item) {
        this.$router.push({
          path: '/site_create_form', query: {
            type: 'news',
            spiderClassId: 12,
            domain: item.domain,
            label: item.labelName ? item.labelName : '',
            spiderTagId: item.spiderTagId ? item.spiderTagId : '',
            newSiteId: item.id
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .task-manage-container {
        width: 100%;
        padding: 16px;
        position: relative;

        .table-container {
            background-color: white;
            padding: 0 16px;
            margin-top: 16px;
        }
    }

    ul {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 10px;
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        margin: 0;

        li {
            height: 40px;
            line-height: 40px;
            padding: 0 13px;
            border: 1px solid #ddd;
            border-radius: 3px;
            margin: 0 10px 10px 0;
            cursor: pointer;
        }

        li.checked {
            background: #1890ff;
            color: #fff;
        }
    }
    .dot{
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: dodgerblue;
        position: relative;
        top: -2px;
    }
    .red{
        background: red;
    }
    .green{
        background: green;
    }

</style>
<style>
    a:visited{
        color: rgb(119,28,170);
    }
</style>
